import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

import FeatureFlags from '../../../util/featureFlags';

// Actions
import { showModal } from '../../../actions/ModalActions';
import { resetMapping } from '../../../actions/GuestImportActions';
import { fetchChart } from '../../../actions/SeatingChartActions';

// Components
import Loader from '../../common/ui/Loader';
import Onboarding from './Onboarding/Onboarding';
import Header from './Header/Header';
import ListView from './ListView/ListView';
import ChartView from './ChartView/ChartView';
import MatchGuestList from '../guestlist/upload/MatchGuestList';
import MobileView from './MobileView/MobileView';

// Styles
import './SeatingChart.styles.less';

const SeatingChart = ({
  bannerText,
  bannerType,
  busy,
  chartUUID,
  isMapping,
  onUploadSpreadsheet,
  selectedGuests,
  tableUUIDs,
  onboarding,
  updateChart,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 996 });
  const shortNav = useMediaQuery({ maxWidth: 1200 });

  // useState
  const [view, setView] = useState('LIST');
  const [flowRunId, setFlowRunId] = useState(undefined);

  const isMounting = useRef(true); // useRef to keep track of initial load value:
  useEffect(() => { // if mapping ends update seating chart
    if (!isMapping && !isMounting.current) updateChart(chartUUID);
    if (isMounting.current) isMounting.current = false;
  }, [isMounting, isMapping]);

  const updateFlowRunId = () => setFlowRunId(chartUUID + Date.now().toString());

  useEffect(() => updateFlowRunId(), []);

  // conditional states:
  if (busy) return <div className="sc__loader"><Loader /></div>;
  if (isMobile) return <MobileView />;
  if (onboarding) return <Onboarding />;

  if (isMapping) return <MatchGuestList onTryAgain={() => onUploadSpreadsheet(flowRunId, updateFlowRunId)} flowRunId={flowRunId} updateFlowRunId={updateFlowRunId} />;

  return (
      <div className="sc">
        <Header shortenCopy={shortNav} />
        {view === 'LIST' && (
          <ListView
            tableCount={tableUUIDs.length}
            numSelectedGuests={selectedGuests.couple.length + selectedGuests.guests.length}
            setView={setView}
            banner={{ bannerText, bannerType }}
            flowRunId={flowRunId}
            updateFlowRunId={updateFlowRunId}
          />
        )}
        {FeatureFlags.get('seatingChartView2') && view === 'CHART' && (
          <ChartView
            peopleCount={selectedGuests.couple.length + selectedGuests.guests.length}
            setView={setView}
            tableCount={tableUUIDs.length}
            view={view}
          />
        )}
      </div>
  );
};


SeatingChart.propTypes = {
  busy: PropTypes.bool,
  chartUUID: PropTypes.string,
  isMapping: PropTypes.bool,
  onUploadSpreadsheet: PropTypes.func,
  tableUUIDs: PropTypes.arrayOf(PropTypes.string),
  selectedGuests: PropTypes.shape({
    guests: PropTypes.array,
    couple: PropTypes.array,
  }),
  onboarding: PropTypes.bool,
};

const mapStateToProps = state => ({
  busy: state.seatingChart.busy,
  isMapping: state.guestList.guestImport.isMapping,
  tableUUIDs: state.seatingChart.orderedTableUUIDs,
  couple: state.guestRail.couple,
  selectedGuests: state.seatingChart.selectedGuests,
  onboarding: state.seatingChart.onboarding,
  bannerType: state.seatingChart.bannerType,
  bannerText: state.seatingChart.bannerText,
  chartUUID: state.seatingChart.seatingChart.uuid,
});

const mapDispatchToProps = dispatch => ({
  onUploadSpreadsheet: (flowRunId, updateFlowRunId) => {
    dispatch(showModal('ADD_GUEST_GROUP', {
      callback: () => dispatch(resetMapping()), // reset data on open… TODO: make a callback available to modals when closing
      formIdentifier: 'addGuestGroupForm',
      activeTab: 'UPLOAD_SPREADSHEET',
      sendLinkVisible: false,
      flowRunId,
      updateFlowRunId,
    },
    { size: 'md' }));
    dispatch(resetMapping());
  },
  updateChart: uuid => dispatch(fetchChart(uuid))
});

export default connect(mapStateToProps, mapDispatchToProps)(SeatingChart);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/SeatingChart.jsx